import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const API = process.env.REACT_APP_API_URL || 'https://api.bustisha.com/api';

const style = document.createElement('style');
style.textContent = `
  .whatsapp-float {
    position: fixed;
    bottom: 24px;
    right: 24px;
    z-index: 999;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.25s ease;
    text-decoration: none;
  }
  .whatsapp-float:hover { transform: scale(1.08); }
  .whatsapp-float-icon {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #25D366;
    color: #fff;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(37, 211, 102, 0.4);
    transition: box-shadow 0.25s;
  }
  .whatsapp-float:hover .whatsapp-float-icon {
    box-shadow: 0 6px 24px rgba(37, 211, 102, 0.55);
  }
  .whatsapp-float-tooltip {
    background: var(--bg-card, #1e2130);
    border: 1px solid var(--border, #2c2f3e);
    padding: 8px 14px;
    border-radius: 10px;
    font-size: 13px;
    color: var(--text-primary, #e4e6eb);
    white-space: nowrap;
    box-shadow: var(--shadow, 0 8px 24px rgba(0,0,0,0.3));
    opacity: 0;
    transform: translateX(8px);
    transition: all 0.2s ease;
    pointer-events: none;
  }
  .whatsapp-float:hover .whatsapp-float-tooltip {
    opacity: 1;
    transform: translateX(0);
  }
`;
document.head.appendChild(style);

export default function WhatsAppFloat() {
  const [number, setNumber] = useState('');

  useEffect(() => {
    fetch(`${API}/settings/whatsapp`)
      .then((r) => r.json())
      .then((d) => { if (d.number) setNumber(d.number); })
      .catch(() => {});
  }, []);

  if (!number) return null;

  const href = `https://wa.me/${number.replace(/[^0-9]/g, '')}`;

  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="whatsapp-float" title="Chat with support">
      <span className="whatsapp-float-tooltip">Chat with support</span>
      <span className="whatsapp-float-icon">
        <FontAwesomeIcon icon={faWhatsapp} />
      </span>
    </a>
  );
}
